function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "kind",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 58 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1",
    d: "M42.94,33.32l-.85-1.75a14.19,14.19,0,0,0-5.28-6L28.92,21a1.83,1.83,0,0,0-1.84-.19l-4.62,2.64,0-.05-4.55-7.9a5.85,5.85,0,0,0-1-1.33,4.36,4.36,0,0,0-.8-.62L8.15,9a5.56,5.56,0,0,0-3.7-.85L2.15,9.54,2,9.68A5.14,5.14,0,0,0,.56,13.6l0,10.46V27L22.35,63.57,43.78,52.51l.51-.31,0-13.33a13.08,13.08,0,0,0-1.4-5.55",
    style: {
      fill: "#34a853"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4",
    d: "M55.72,25.76,54.87,24a14.19,14.19,0,0,0-5.28-6L41.7,13.43a1.83,1.83,0,0,0-1.84-.19l-4.62,2.64L22.42,23.39l0,.05,4.62-2.64a1.83,1.83,0,0,1,1.84.19l7.89,4.55a14.2,14.2,0,0,1,5.28,6l.85,1.75a13.06,13.06,0,0,1,1.4,5.55l0,13.34,9.76-6,3-1.83,0-13.11a13.08,13.08,0,0,0-1.4-5.55",
    style: {
      fill: "#72d37b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6",
    d: "M30.66,7.93a5.78,5.78,0,0,0-1.2-1.46A4.09,4.09,0,0,0,28.81,6L20.93,1.44A4.93,4.93,0,0,0,16.42.84l-.61.37L4.45,8.14A5.56,5.56,0,0,1,8.15,9L16,13.55a4.36,4.36,0,0,1,.8.62,5.87,5.87,0,0,1,1,1.33l4.55,7.9,12.81-7.51Z",
    style: {
      fill: "#0d9158"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKind);
export default __webpack_public_path__ + "static/media/kind.978444d56eaac3a51f07c47f6e43cfd6.svg";
export { ForwardRef as ReactComponent };